export default "__VITE_ASSET__CvVZpn3F__"